<template>
  <div class="batch_import_student">
    <el-dialog
      :title="title"
      :visible.sync="openDialog"
      width="21%"
      class="dialog_title"
      @close="closeDialog"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0">
        <el-form-item label="" prop="is_buy">
          <el-select v-model="ruleForm.is_buy" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submit()">确 定</el-button>
        <el-button @click="openDialog = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  postApiInsureHeadmasterBuyStatus,
  postApiInsureStudentBuyStatus,
  postApiInsureExpertBuyStatus,
} from "@/api/tearcher";
export default {
  props: {},
  data() {
    return {
      title: "批量更改购买状态",
      openDialog: false,
      ruleForm: {
        class_id: sessionStorage.getItem("class_id"),
        is_buy: "",
      },
      rules: {
        is_buy: [{ required: true, message: "请选择购买状态", trigger: "change" }],
      },
      options: [
        { label: "未购买", value: 1 },
        { label: "已购买", value: 2 },
      ],
      postApi: "",
    };
  },
  methods: {
    // 关闭dialog
    closeDialog() {
      // 重置
      this.$refs.ruleForm.resetFields();
    },
    // 操作dialog
    operationDialog(roleType, tableSelection) {
      let user_id = "";
      if (tableSelection.length > 0) {
        let ids = [];
        tableSelection.forEach((item) => {
          if (roleType == 0) {
            ids.push(item.id);
          }
          if (roleType == 1) {
            ids.push(item.teacher_id);
          }
          if (roleType == 2) {
            ids.push(item.expert_id);
          }
        });
        user_id = ids.join(",");
      }
      if (roleType == 0) {
        this.postApi = postApiInsureStudentBuyStatus;
        this.ruleForm.class_user_id = user_id;
      }
      if (roleType == 1) {
        this.postApi = postApiInsureHeadmasterBuyStatus;
        this.ruleForm.teacher_ids = user_id;
      }
      if (roleType == 2) {
        this.postApi = postApiInsureExpertBuyStatus;
        this.ruleForm.expert_ids = user_id;
      }
      this.openDialog = true;
    },
    // 确定
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.postApi(this.ruleForm).then((res) => {
            this.$emit("submitScuuess");
            this.openDialog = false;
            this.$message({
              message: "操作成功",
              type: "success",
            });
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
